export type AnalyticsEvent = 'Form Started' | 'Form Field Filled' | 'Form Step Completed' | 'Form Submitted';

export function genFormId(): string {
    if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
        return crypto.randomUUID();
    }

    return 'frm_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function now(): number {
    return Date.now();
}

export function pagePath(): string {
    if (typeof window === 'undefined') {
        return '';
    }

    try {
        const { pathname, search } = window.location;
        return `${pathname}${search}`;
    } catch {
        return '';
    }
}

export type CommonProps = {
    form_id: string;
    form_name: string;
    page_path: string;
    ts: number;
    elapsed_ms?: number;
};
